import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-delivery-terms',
  templateUrl: './delivery-terms.component.html',
  styleUrls: ['./delivery-terms.component.css']
})
export class DeliveryTermsComponent implements OnInit {
    itemsListTerms: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadTerms(): Promise<void> {
        this.itemsListTerms = await this.datatask.Post(623);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'deliveryterm':
                this.stateService?.go('deliveryterm', { deliveryterm_no: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadTerms();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryTerms', {
//        templateUrl: 'views/components/views/deliveryTerms/deliveryTerms.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'deliveryTermsService', function (stateService, deliveryTermsService) {
//            const vm = this;

//            vm.model = {
//                itemsListTerms: []
//            };

//            async function loadDeliveryTerms() {
//                vm.model.itemsListTerms = (await deliveryTermsService.listDeliveryTerms());
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'deliveryterm':
//                        go({ deliveryterm_no: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadDeliveryTerms();
//            };
//        }]
//    });
//})();
